import { Inversify } from '@/src/shared/utils/Inversify';

import type { IServerEnvVars } from '../interfaces/server-env-vars.types';

/*
 *  /api starting paths refer to pages/api proxy routes
 */
@Inversify.injectable('instance')
export default class ServerEnvVars implements IServerEnvVars {
  cmsApiUrl: string = process.env.CMS_URL;
  cmsJsonApiKey: string = process.env.CMS_JSONAPI_API_KEY;

  get isProduction() {
    return process.env.NODE_ENV === 'production';
  }
}
